var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.22656C0.75 2.89896 3.57899 0.25 7 0.25C10.421 0.25 13.25 2.89896 13.25 6.22656C13.25 8.10252 12.2357 10.4235 11.1246 12.4296C9.99688 14.4658 8.69812 16.3003 8.00162 17.2409C7.8867 17.398 7.73642 17.5259 7.56292 17.6142C7.38854 17.7029 7.19565 17.7492 7 17.7492C6.80434 17.7492 6.61146 17.7029 6.43708 17.6142C6.26356 17.5259 6.11327 17.398 5.99834 17.2408C5.30187 16.2999 4.0031 14.4647 2.87536 12.4283C1.76432 10.422 0.75 8.10119 0.75 6.22656ZM7 1.5C4.21007 1.5 2 3.64713 2 6.22656C2 7.75037 2.86068 9.82155 3.96888 11.8227C5.05739 13.7883 6.3182 15.5716 7 16.493C7.68177 15.5721 8.9426 13.7894 10.0311 11.824C11.1393 9.82318 12 7.75177 12 6.22656C12 3.64713 9.78993 1.5 7 1.5Z",
    fill: "url(#paint0_linear_40597_31816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.25C6.30964 5.25 5.75 5.80964 5.75 6.5C5.75 7.19036 6.30964 7.75 7 7.75C7.69036 7.75 8.25 7.19036 8.25 6.5C8.25 5.80964 7.69036 5.25 7 5.25ZM4.5 6.5C4.5 5.11929 5.61929 4 7 4C8.38071 4 9.5 5.11929 9.5 6.5C9.5 7.88071 8.38071 9 7 9C5.61929 9 4.5 7.88071 4.5 6.5Z",
    fill: "url(#paint1_linear_40597_31816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40597_31816",
    x1: 1,
    y1: 5.5,
    x2: 13,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E77B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8989FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#6C9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#78CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF4A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40597_31816",
    x1: 1,
    y1: 5.5,
    x2: 13,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E77B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8989FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#6C9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#78CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FF4A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fc16191b1e9752cbe52446f4554dee88.svg";
export { ForwardRef as ReactComponent };